import { generateClient, GraphQLResult } from "aws-amplify/api";
// @ts-ignore
import { getFormGroupInProject } from "../graphql/queries";
import { recordSentry } from "./recordSentry";
import { FormGroup } from "db/definitions";

async function getFormGroupForProject(id: string): Promise<FormGroup | null> {
	try {
		interface QueryResponse {
			getFormGroup: FormGroup;
		}
		const client = generateClient({ authMode: "userPool" });
		const result = (await client.graphql({
			query: getFormGroupInProject,
			variables: {
				id: id,
				nextToken: null,
			},
			authMode: "userPool",
		})) as GraphQLResult<QueryResponse>;

		return result.data.getFormGroup;
	} catch (error) {
		recordSentry({ error, msg: "Error getting form group for project: " });
	}
	return null;
}

export default getFormGroupForProject;
